import { PageHero, Section } from "@/components/SharedUI";

export default function LegalPage({ title, eyebrow, lastUpdated, sections }) {
  return (
    <>
      <PageHero
        eyebrow={eyebrow}
        title={title}
        desc="This page is a working draft. It will be reviewed, finalised and circulated before public launch. Please contact Bigibila Consultancy directly for current binding terms."
      />
      <section className="border-b border-stone-200">
        <Section>
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
            <aside className="lg:col-span-3">
              <div className="lg:sticky lg:top-28">
                <div className="text-[10px] tracking-[0.28em] uppercase font-bold text-stone-500 mb-3">Status</div>
                <div className="border border-amber-300 bg-amber-50 text-amber-900 p-4 text-sm">
                  <div className="font-semibold mb-1">DRAFT</div>
                  <div className="text-xs leading-relaxed">Working text only. Not yet finalised for publication.</div>
                </div>
                {lastUpdated && (
                  <div className="mt-5 text-xs text-stone-500">
                    Last updated: <span className="text-stone-700">{lastUpdated}</span>
                  </div>
                )}
                <div className="mt-5 text-xs text-stone-500 leading-relaxed">
                  Final version will be circulated for review with custodians, advisors and counsel before any public binding use.
                </div>
              </div>
            </aside>
            <article className="lg:col-span-9 space-y-12">
              {sections.map((s) => (
                <section key={s.heading} data-testid={`legal-section-${s.heading.toLowerCase().replace(/\s+/g, '-')}`}>
                  <h2 className="font-display text-2xl md:text-3xl tracking-tight font-bold text-stone-900">{s.heading}</h2>
                  <div className="mt-4 space-y-4 text-stone-700 leading-relaxed max-w-3xl">
                    {s.body.map((p) => <p key={p}>{p}</p>)}
                  </div>
                </section>
              ))}
            </article>
          </div>
        </Section>
      </section>
    </>
  );
}
